class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  async renderContents(parsedState) {
    this.productId = parsedState.id;
    try {
      const sections = this.getSectionsToRender().filter(section => document.getElementById(section.id));
      const contents = await Promise.all(sections.map(async section => {
        let html = this.getSectionInnerHTML(parsedState.sections?.[section.section], section.selector);

        // The cart mutation can succeed even when its bundled HTML is missing.
        // Fetch only the missing markup; never repeat the add-to-cart request.
        if (html === null) {
          const url = new URL(this.dataset.url, window.location.origin);
          url.searchParams.set('section_id', section.section);
          const response = await fetch(url.toString(), { cache: 'no-store' });
          if (!response.ok) throw new Error(`Unable to load cart section: ${section.section}`);
          html = this.getSectionInnerHTML(await response.text(), section.selector);
          if (html === null) throw new Error(`Invalid cart section: ${section.section}`);
        }

        return { id: section.id, html };
      }));

      contents.forEach(({ id, html }) => {
        const element = document.getElementById(id);
        if (element) element.innerHTML = html;
      });
      this.open();
    } catch (error) {
      console.error(error);
      // The product was already added. Show the cart if its drawer cannot recover.
      window.location.assign(theme.routes.cart_url);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string' || !html.trim()) return null;
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML ?? null;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
